import React from 'react';
import classes from './ContactForm.module.css';


const contact = () => (
    <div className={classes.All}>
        <div className={classes.Background}><h2>Contact Me!</h2></div>
        <p>Mayara Caldeira Smith</p>
        <p>mayaracsmith@gmail.com</p>
        <p>(704) 798-9025</p>
       </div>
);

export default contact;